module.exports = __webpack_public_path__ + "media/img/portal/bloquote-cbbd4476b4d1a8ea8ebcd8f20417f24d.svg";